import { rgba } from "polished";
import styled from "styled-components";

export const ActionsContainer = styled.div`
  display: grid;
  gap: ${(props) => props.theme.space[2]};
  width: 100%;
  /* Mobile default: two buttons per row, last one full-width below */
  grid-template-columns: repeat(2, 1fr);

  & > *:last-child {
    grid-column: 1 / -1;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));

    & > *:last-child {
      grid-column: auto;
    }
  }
`;

export const StickyWrapper = styled.div`
  position: sticky;
  z-index: 1;
  bottom: 0;
  padding: ${(props) => `${props.theme.space[3]} ${props.theme.space[1]}`};
  background: ${({ theme }) => `linear-gradient(
   to top,
    ${rgba(theme.colors.white, 0.9)} 93%,
    ${rgba(theme.colors.white, 0.4)} 97%,
    ${rgba(theme.colors.white, 0.1)} 99%
  )`};
`;
